import { render, staticRenderFns } from "./bank-info.vue?vue&type=template&id=16ef9992&scoped=true"
import script from "./bank-info.vue?vue&type=script&lang=js"
export * from "./bank-info.vue?vue&type=script&lang=js"
import style0 from "./bank-info.vue?vue&type=style&index=0&id=16ef9992&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef9992",
  null
  
)

export default component.exports